import { render, staticRenderFns } from "./medium.vue?vue&type=template&id=c881046a&scoped=true"
import script from "./medium.vue?vue&type=script&lang=js"
export * from "./medium.vue?vue&type=script&lang=js"
import style0 from "./medium.vue?vue&type=style&index=0&id=c881046a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c881046a",
  null
  
)

export default component.exports